import { render, staticRenderFns } from "./DormancyAccountForm.vue?vue&type=template&id=43aa75bb"
import script from "./DormancyAccountForm.vue?vue&type=script&lang=js"
export * from "./DormancyAccountForm.vue?vue&type=script&lang=js"
import style0 from "./DormancyAccountForm.vue?vue&type=style&index=0&id=43aa75bb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports